import { jsx as C } from "react/jsx-runtime";
const r = ({
  width: o,
  height: t,
  className: e
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: e,
    fill: "none",
    height: t,
    viewBox: "0 0 23 16",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M22.5262 2.50287C22.391 2.01712 22.1329 1.57566 21.7773 1.22235C21.4218 0.869041 20.9813 0.616183 20.4995 0.488867C18.7 8.88109e-06 11.5 0 11.5 0C11.5 0 4.3009 3.45707e-06 2.5004 0.470681C2.01893 0.604957 1.57965 0.862495 1.22473 1.21856C0.869803 1.57463 0.611168 2.01725 0.473714 2.50389C-0.157905 6.14033 -0.157905 9.86069 0.473714 13.4971C0.608941 13.983 0.867305 14.4245 1.22302 14.7779C1.57874 15.1312 2.01947 15.384 2.50143 15.5111C4.31987 16 11.5009 16 11.5009 16C11.5009 16 18.6999 16 20.5004 15.5293C20.9822 15.402 21.4228 15.1491 21.7783 14.7958C22.1338 14.4425 22.392 14.0011 22.5272 13.5153C22.8535 11.7021 23.012 9.86183 23.0005 8.01868C23.022 6.16873 22.8631 4.32115 22.5262 2.50287ZM9.20721 11.4256V4.57343L15.1936 7.99948L9.20721 11.4256Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  r as Content
};
